export { ClindxTableFilterType } from 'src/app/core/classes/clindx-table-config';
export { AuditActivityTypeArgs } from './audit-activity-type';
export { Constants } from 'src/app/shared/constants';

export const HEAD_EXSHORT = 'head-exshort';
export const HEAD_SHORT = 'head-short';
export const OVERFLOW_CONTROL = 'overflow-control';
export const EMAIL_COLUMN_CLASS = 'overflow-control-content-wrap email-column';
export const OVERFLOW_CONTROL_CONTENT_WRAP = 'overflow-control-content-wrap';
export const PADDING_RIGHT = 'padding-right';
export const HEAD_EXSHORT_PADDING_RIGHT = 'head-exshort padding-right';
export const HEAD_EXSHORT_PADDING_RIGHT_REPORT = 'head-exshort padding-right-report';
export const REQUISITION_NUMBER_LABEL = 'Requisition #';
export const HEAD_SELECT = 'head-select';
export const OVERFLOW_CONTROL_CONTENT_WRAP_MANAGE_PACKAGE_GRID = 'overflow-control-contentWrap-managePackageGrid';
export const HEAD_MEDIUM = 'head-medium';
export const TEXT_CENTER = 'text-center';
export const TEXT_CENTER_OVERFLOW_CONTROL = 'text-center overflow-control';
export const ACCESSION_ID = 'Accession ID';
export const OVERFLOW_CONTROL_CONTENTWRAP_RESULT_GRID = 'overflow-control-contentWrap-resultGrid';
export const DOB_FORMAT = 'DOB (MM/DD/YYYY)';
export const FIRST_NAME = 'First Name';
export const HEAD_CREATION_DATE = 'head-creationDate';
export const DATA_CREATION_DATE = 'data-creationDate';
export const LAST_UPDATED_ON = 'Last Updated On';
export const LAST_UPDATED_BY = 'Last Updated By';
export const ANNOUNCEMENT_LAST_UPDATED_ON = 'Last updated on';
export const ANNOUNCEMENT_LAST_UPDATED_BY = 'Last updated by';
export const PATIENT_NAME = 'Patient Name';
export const OVERFLOW_CONTROL_PURCHASETABLE = 'overflow-control purchaseTable';